import useSettingsService from 'components/hooks/useSettingsService';
import { ValidationError } from 'common/constants/error-types';
import { SettingValues } from '@linearb/linjs-common';

const usePmTagsFetchStrategySetting = () => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const pmIssueTagsStrategySetting = getSettingOrDefinitionValue({
    name: SettingValues.PM_ISSUE_TAGS_FETCH_STRATEGY
  });

  const defaultPattern = pmIssueTagsStrategySetting?.default_pattern;
  const customPattern = pmIssueTagsStrategySetting?.custom_pattern;

  const validatePattern = pattern => {
    try {
      new RegExp(pattern);
      return true;
    } catch (e) {
      return false;
    }
  };

  const onSave = async pattern => {
    if (!validatePattern(pattern))
      throw new ValidationError('Regex pattern is invalid');
    await updateSetting(SettingValues.PM_ISSUE_TAGS_FETCH_STRATEGY, {
      custom_pattern: pattern
    });
  };

  const onDelete = async () =>
    await updateSetting(SettingValues.PM_ISSUE_TAGS_FETCH_STRATEGY, null);

  return {
    defaultPattern,
    customPattern,
    onSave,
    onDelete
  };
};

export default usePmTagsFetchStrategySetting;
